module.exports = __webpack_public_path__ + "img/vip8.12df6982.png";